import { api } from '@/api/main.api'

export async function apiGetUserInfo () {
  return api('get', '/auth/info')
}

export async function apiLogout () {
  return api('get', '/auth/logout')
}

export async function apiLogin (email, password) {
  return api('post', '/auth/login', { email, password })
}

export async function apiSignup (data) {
  return api('post', '/auth/register', data)
}

export async function apiGetInviteKey (inviteKey) {
  return api('get', '/auth/projectInviteKey', {params: { inviteKey: inviteKey }})
}

export async function apiPasswordReset (email) {
  return api('post', '/auth/passwordReset', { email })
}

export async function apiGetPasswordReset (email, token) {
  return api('get', '/auth/passwordReset', { params: { email, token } })
}

export async function apiUploadUserAvatar (param) {
  return api('post', '/upload/file', param)
}

export async function apiUpdateUser (param) {
  return api('post', '/user', param)
}

export async function apiUserPayment (param) {
  return api('post', '/user/payment', param)
}

export async function apiUserProfileUpdate (param) {
  return api('post', '/profile/update', param)
}

// users page
export async function apiGetUsers () {
  return api('get', '/user/list')
}

export async function apiCreateUser (param) {
  return api('post', '/user', param)
}

export async function apiDeleteUser (id) {
  return api('delete', `/user/${id}`)
}



// WEBPACK FOOTER //
// ./src/api/user.api.js